import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const BackArrow: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.6503 3.12408H3.9176L4.80323 1.80804C4.92135 1.63394 4.98981 1.43095 5.00125 1.22088C5.01269 1.0108 4.96668 0.801577 4.86816 0.615683C4.76964 0.42979 4.62233 0.27425 4.44207 0.165776C4.2618 0.057301 4.05538 -9.86733e-06 3.845 3.0707e-09H3.84258C3.65334 -1.31988e-05 3.46652 0.042543 3.29595 0.124517C3.12538 0.206491 2.97544 0.325784 2.85723 0.473561L0.132443 3.88005C0.0467084 3.98722 0 4.12038 0 4.25763C0 4.39487 0.0467084 4.52803 0.132443 4.6352L2.85753 8.04146C2.97574 8.18925 3.12568 8.30856 3.29624 8.39055C3.46681 8.47254 3.65363 8.5151 3.84288 8.5151H3.845C4.05537 8.5151 4.26177 8.45779 4.44203 8.34931C4.62228 8.24084 4.76958 8.08531 4.8681 7.89943C4.96662 7.71355 5.01263 7.50434 5.0012 7.29428C4.98977 7.08421 4.92133 6.88123 4.80323 6.70714L3.91738 5.39064H12.6503C13.9984 5.39064 15.2913 5.92619 16.2446 6.87946C17.1979 7.83273 17.7334 9.12565 17.7334 10.4738C17.7334 11.8219 17.1979 13.1148 16.2446 14.0681C15.2913 15.0214 13.9984 15.5569 12.6503 15.5569H10.1786C9.87804 15.5569 9.58979 15.6763 9.37725 15.8889C9.16472 16.1014 9.04532 16.3896 9.04532 16.6902C9.04532 16.9908 9.16472 17.279 9.37725 17.4916C9.58979 17.7041 9.87804 17.8235 10.1786 17.8235H12.6503C14.5996 17.8235 16.469 17.0492 17.8473 15.6708C19.2257 14.2925 20 12.423 20 10.4738C20 8.52452 19.2257 6.6551 17.8473 5.27676C16.469 3.89842 14.5996 3.12408 12.6503 3.12408Z"
        fill="currentColor"
      />
    </svg>
  )
})

BackArrow.displayName = 'BackArrow'
